import QueryContext from '../QueryContext';
import api from '../index';

const ORGANIZATION_BRANDS_INCLUDE = [
  'brands.tiktok_business_authorizations',
  'brands.brand_instagram_business_account',
];

const organizationBrandsFetchers = {
  organizationBrands: (context: QueryContext) => {
    const brandId = context.meta?.brandId;
    return api.get('/domain/agency', {
      params: {
        brand_id: brandId,
        include: ORGANIZATION_BRANDS_INCLUDE.join(','),
      },
    });
  },
};

export default organizationBrandsFetchers;
